import React from 'react'
import {createIcon} from '@chakra-ui/react'

import {colors} from '../theme/foundations/colors'

const viewBox = '0 0 24 24'

const path = ({tick, circle}) => (
  <>
    <circle
      cx="12"
      cy="12"
      r="11"
      stroke={circle.stroke}
      strokeWidth="2"
      fill={circle.fill}
    />
    <path
      d="M 17.508,6.696 9.6,14.604 6.492,11.508 4.8,13.2 9.6,18 19.2,8.4 Z"
      fill={tick.fill}
    />
  </>
)

export const SolidTickedIcon = createIcon({
  displayName: 'SolidTickedIcon',
  viewBox,
  path: path({
    circle: {
      fill: 'currentColor',
      stroke: 'currentColor',
    },
    tick: {
      fill: colors.mld.neutral[0],
    },
  }),
})

export const InverseSolidTickedIcon = createIcon({
  displayName: 'InverseSolidTickedIcon',
  viewBox,
  path: path({
    circle: {
      fill: colors.mld.neutral[50],
      stroke: colors.mld.neutral[50],
    },
    tick: {
      fill: colors.mld.neutral[1000],
    },
  }),
})

export const InverseTickedIcon = createIcon({
  displayName: 'InverseTickedIcon',
  viewBox,
  path: path({
    circle: {
      fill: 'currentColor',
      stroke: colors.mld.neutral[50],
    },
    tick: {
      fill: colors.mld.neutral[1000],
    },
  }),
})

export const TickedIcon = createIcon({
  displayName: 'TickedIcon',
  viewBox,
  path: path({
    circle: {
      fill: 'transparent',
      stroke: 'currentColor',
    },
    tick: {
      fill: 'currentColor',
    },
  }),
})

export const TickedOutlineIcon = createIcon({
  displayName: 'TickedOutlineIcon',
  viewBox,
  path: path({
    circle: {
      fill: 'transparent',
      stroke: 'currentColor',
    },
    tick: {
      fill: 'currentColor',
    },
  }),
})

export const SmallInverseTickedIcon = createIcon({
  displayName: 'SmallInverseTickedIcon',
  viewBox,
  path: path({
    circle: {
      fill: colors.mld.neutral[900],
      stroke: 'currentColor',
    },
    tick: {
      fill: colors.mld.neutral[50],
    },
  }),
})
